import { createReducer, on } from '@ngrx/store';
import { TrialCampaignStatus, TrialsState } from '@ra-state';
import {
  clearTrialGridRefresh,
  refreshTrialGrid,
  resetCampaignDetails,
  setCampaignDetails,
  setTrialBundles,
} from './trials.action';

export const initialTrialsState: TrialsState = {
  campaignDetails: {
    bundleId: '',
    campaignType: 'organization',
    createdByUser: '',
    createdByUserId: '',
    createdOn: '',
    description: '',
    endedByUser: '',
    endedByUserId: '',
    endedOn: '',
    id: '',
    name: '',
    partitionId: '',
    pausedByUser: '',
    pausedByUserId: '',
    pausedOn: '',
    redeemedTrials: 0,
    reservedTrials: 0,
    status: '' as TrialCampaignStatus,
    trialDurationInDays: '',
    trialRedemptionLimitInDays: 0,
    viewType: '',
    perTrialCredits: 0,
    credits: 0,
    trialsQuantity: 0,
    remainingTrialsQuantity: 0,
  },
  trialBundles: [
    {
      id: '',
      nameAndDescription: ['', ''],
      creditsAndProductCatalogs: [],
      name: '',
      description: '',
      credits: null,
      isActive: false,
      products: [],
    },
  ],
  refreshGrid: false,
};

export const trialsReducer = createReducer(
  initialTrialsState,
  on(
    setCampaignDetails,
    (state: TrialsState, { payload }): TrialsState => ({
      ...state,
      campaignDetails: payload,
    }),
  ),
  on(
    setTrialBundles,
    (state: TrialsState, { payload }): TrialsState => ({
      ...state,
      trialBundles: payload,
    }),
  ),
  on(
    refreshTrialGrid,
    (state: TrialsState): TrialsState => ({
      ...state,
      refreshGrid: true,
    }),
  ),
  on(
    clearTrialGridRefresh,
    (state: TrialsState): TrialsState => ({
      ...state,
      refreshGrid: false,
    }),
  ),
  on(
    resetCampaignDetails,
    (state: TrialsState): TrialsState => ({
      ...state,
      campaignDetails: initialTrialsState.campaignDetails,
    }),
  ),
);
